import { render } from "./WrapFooter.vue?vue&type=template&id=1be45aaa&scoped=true"
import script from "./WrapFooter.vue?vue&type=script&lang=js"
export * from "./WrapFooter.vue?vue&type=script&lang=js"

import "./WrapFooter.vue?vue&type=style&index=0&id=1be45aaa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1be45aaa"

export default script